<template>
  <div class="login-container">
    <!-- 科技感背景 -->
    <div class="login-bg">
      <div class="bg-glow"></div>
      <div class="bg-grid"></div>
    </div>

    <!-- 居中内容区（标题 + 表单） -->
    <div class="login-content">
      <!-- 系统标题 -->
      <div class="system-info">
        <h1 class="system-name">安全环保实时监管一体化平台</h1>
        <p class="system-desc">风险溯源 ・ 动态监管 ・ 绿色安防</p>
      </div>

      <!-- 登录表单卡片 -->
      <div class="login-card">
        <el-form
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
              size="large"
              class="login-input"
              clearable
            />
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="large"
              class="login-input"
              show-password
              clearable
            />
          </el-form-item>

          <el-form-item class="login-actions">
            <el-checkbox v-model="loginForm.remember" class="remember-checkbox">
              记住密码
            </el-checkbox>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              size="large"
              class="login-btn"
              @click="handleLogin"
              :loading="loginLoading"
            >
              登 录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";

const router = useRouter();
const loginFormRef = ref(null);
const loginLoading = ref(false);

const loginForm = reactive({
  username: "",
  password: "",
  remember: false,
});

const loginRules = reactive({
  username: [
    { required: true, message: "请输入账号", trigger: "blur" },
    { min: 3, max: 20, message: "账号长度在 3 到 20 个字符", trigger: "blur" },
  ],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    { min: 6, max: 20, message: "密码长度在 6 到 20 个字符", trigger: "blur" },
  ],
});

const handleForgetPwd = () => {
  ElMessageBox.alert("请联系系统管理员重置密码", "忘记密码", {
    confirmButtonText: "确 定",
    type: "info",
  });
};

const handleLogin = async () => {
  try {
    await loginFormRef.value.validate();
  } catch (error) {
    ElMessage.error("请完善登录信息");
    return;
  }

  loginLoading.value = true;
  try {
    await new Promise((resolve) => setTimeout(resolve, 1200));
    if (loginForm.password !== "www.yinchun.com")
      return ElMessage.error("密码或账号账号错误");

    localStorage.setItem("token", "law_enforce_token_" + Date.now());
    if (loginForm.remember) {
      localStorage.setItem("login_username", loginForm.username);
      localStorage.setItem("login_remember", "1");
    } else {
      localStorage.removeItem("login_username");
      localStorage.removeItem("login_remember");
    }

    ElMessage.success("登录成功，欢迎使用安全环保实时监管一体化平台！");
    router.push("/home");
  } catch (error) {
    ElMessage.error("账号或密码错误，请重试");
  } finally {
    loginLoading.value = false;
  }
};

onMounted(() => {
  const remember = localStorage.getItem("login_remember");
  const username = localStorage.getItem("login_username");
  if (remember && username) {
    loginForm.username = username;
    loginForm.remember = true;
  }
});
</script>

<style scoped>
/* 全局容器 */
.login-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #0a1020;
  overflow: hidden;
}

/* 科技感背景 */
.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #050b1a 0%, #0f1a30 100%);
}

.bg-glow {
  position: absolute;
  width: 80%;
  height: 80%;
  left: 10%;
  top: 10%;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 70%
  );
  border-radius: 50%;
}

.bg-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 191, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 191, 255, 0.1) 1px, transparent 1px);
  background-size: 40px 40px;
  pointer-events: none;
}

/* 居中内容区（标题+表单） */
.login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px; /* 标题和表单之间的间距 */
  z-index: 10;
}

/* 系统标题 */
.system-info {
  text-align: center;
}

.system-name {
  font-size: 42px;
  color: #ffffff;
  text-shadow: 0 0 20px rgba(0, 191, 255, 0.5);
  font-weight: 700;
  margin: 0 0 12px;
  letter-spacing: 2px;
}

.system-desc {
  font-size: 18px;
  color: #87ceeb;
  opacity: 0.8;
  letter-spacing: 1px;
  margin: 0;
}

/* 登录卡片 */
.login-card {
  width: 420px;
  padding: 40px;
  background-color: rgba(15, 26, 48, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(0, 191, 255, 0.2);
  box-shadow: 0 0 40px rgba(0, 191, 255, 0.15);
}

/* 登录表单 */
.login-form {
  width: 100%;
}

.login-input {
  --el-input-bg-color: rgba(5, 11, 26, 0.6);
  --el-input-border-color: rgba(0, 191, 255, 0.3);
  --el-input-text-color: #ffffff;
  --el-input-placeholder-color: rgba(255, 255, 255, 0.5);
  --el-input-hover-border-color: #00bfff;
  border-radius: 8px;
}

.login-input :deep(.el-input__wrapper) {
  background-color: rgba(5, 11, 26, 0.6) !important;
  border: 1px solid rgba(0, 191, 255, 0.3) !important;
  box-shadow: none !important;
}

.login-input :deep(.el-input__inner) {
  color: #ffffff !important;
}

/* 登录操作区 */
.login-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.remember-checkbox :deep(.el-checkbox__label) {
  color: #b0c8e8;
  font-size: 14px;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #0099ff, #0066cc) !important;
  border: none !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 2px !important;
  box-shadow: 0 4px 15px rgba(0, 153, 255, 0.3) !important;
}

.login-btn:hover {
  background: linear-gradient(135deg, #00bfff, #0088ff) !important;
}
</style>
